import React, { useEffect, useState } from "react";
import { FieldArray, useField } from "formik";
import { TrashIcon, PlusIcon } from "@heroicons/react/outline";
import SelectBox from "components/FormElements/SelectBox";
import BaseElement from "components/FormElements/BaseElement";
import MetaProperty, { metaProperties } from "./MetaProperty";
import SecondaryButton from "components/Buttons/SecondaryButton";

export default function FieldlistMetaProperty(props) {
    const [field, meta] = useField(props);
    const [fields, setFields] = useState([]);
    const { fieldtype, fieldmeta } = props.metaProps;

    const addField = () => {
        setFields([...fields, null]);
    };

    useEffect(() => {
        if (field.value) {
            setFields(field.value);
        }
    }, [field.value]);

    const input = (
        <div>
            <FieldArray
                name={field.name}
                render={(arrayHelpers) => (
                    <div className="relative w-full cursor-default space-y-2 disabled:opacity-50 sm:text-sm">
                        {fields.map((f, index) => {
                            return (
                                <div
                                    key={index}
                                    className="flex w-full space-x-2"
                                >
                                    <div className="flex-grow">
                                        <MetaProperty
                                            type={fieldtype}
                                            value={""}
                                            field={
                                                field.name + "[" + index + "]"
                                            }
                                            metaProps={fieldmeta}
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            arrayHelpers.remove(index);
                                        }}
                                    >
                                        <TrashIcon className="h-6 w-6 text-gray-500" />
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                )}
            />
            <SecondaryButton
                onClick={addField}
                variant="xs"
                className="flex content-center items-center"
            >
                <PlusIcon className="h-4 w-4" />
            </SecondaryButton>
        </div>
    );

    const label = (
        <label
            htmlFor={props.id}
            className="block text-sm font-medium text-gray-700"
        >
            {props.label}
        </label>
    );

    const helperText = props.helpertext ? (
        <p className="mt-2 text-sm text-gray-500">{props.helpertext}</p>
    ) : (
        ""
    );

    const errorText =
        props.isError || (meta.touched && meta.error) ? (
            <p className="mt-2 text-sm text-red-600">
                {props.errorText}
                {meta.error}
            </p>
        ) : (
            ""
        );

    return (
        <BaseElement
            {...props}
            input={input}
            label={label}
            helpertext={helperText}
            errortext={errorText}
        />
    );
}

export const Property = FieldlistMetaProperty;

export const Label = "Field List";

export function Configure(props) {
    const propList = [
        { label: "Checkbox", value: "CheckboxMetaProperty" },
        {
            label: "Content",
            value: "RelatedcontentMetaProperty",
        },
        { label: "Date", value: "DateMetaProperty" },
        { label: "Datetime", value: "DatetimeMetaProperty" },
        { label: "Editor Text", value: "EditortextMetaProperty" },
        { label: "Secure Text", value: "SecuretextMetaProperty" },
        { label: "File Upload", value: "FileMetaProperty" },
        { label: "JSON Text", value: "JsonMetaProperty" },
        { label: "Rich Text", value: "RichtextMetaProperty" },
        { label: "Single Entry", value: "SelectentryMetaProperty" },
        {
            label: "Multiple Entries",
            value: "RelatedentriesMetaProperty",
        },
        { label: "Long Text", value: "LongtextMetaProperty" },
        { label: "Text", value: "TextMetaProperty" },
        { label: "Author", value: "AuthorsMetaProperty" },
    ];
    const { propertyInfo } = props;

    return (
        <div>
            <SelectBox
                name={`${props.fieldName}.fieldtype`}
                options={propList}
            />
            {propertyInfo &&
                metaProperties[propertyInfo?.props?.fieldtype]?.Configure &&
                React.createElement(
                    metaProperties[propertyInfo?.props?.fieldtype].Configure,
                    {
                        fieldName: `${props.fieldName}.fieldmeta`,
                        index: 1,
                    }
                )}
        </div>
    );
}
